<template>
  <div id="random-stuff" class="content md-layout md-gutter md-alignment-center-center">
    <div class="md-layout-item">
      <h1>{{ $t("Random Stuff") }}</h1>
      <md-empty-state
        md-rounded
        md-icon="construction"
        :md-label="$t('Page Under Construction')"
        :md-description="$t('This page is under construction. It will be available soon!')"
        style="margin-top:45px; width:100%;">
      </md-empty-state>
    </div>
  </div>
</template>

<script>

export default {
  name: 'RandomStuff',
  title: 'Fabrício Ceschin - Random Stuff',
  props: {
    // msg: String,
    // num: Number
  },
  mounted() {
    this.$ga.page('/random');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#random-stuff {
  text-align:center;
}
</style>
